/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import './AddEditFitnessFee.css';
import { handleGetRequest } from '../../services/GetTemplate';
import { handlePostRequest } from '../../services/PostTemplate';
import { useDispatch } from 'react-redux';
import { handlePutRequest } from '../../services/PutTemplate';
import Loader from '../../components/loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function AddEditFee({ onHideSidebar, isEditing, editData, editAble, fetchFeesData }) {
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const feeSchema = Yup.object().shape({
        categoryName: Yup.string().required('Vehicle Category is required').min(2, 'Vehicle Category must be at least 2 characters'),
        gracePeriod: Yup.number().required('Grace Period is required').min(0, 'Grace Period cannot be negative').typeError('Grace Period must be a number'),
        normalFee: Yup.number().required('Normal Fee is required').min(1, 'Normal Fee must be greater than zero').typeError('Normal Fee must be a number'),
        fine: Yup.number().required('Fine is required').min(1, 'Fine must be greater than zero').typeError('Fine must be a number'),
        renewalFee: Yup.number().required('Renewal Fee is required').min(1, 'Renewal Fee must be greater than zero').typeError('Renewal Fee must be a number'),
        expiryDuration: Yup.number()
            .required('Certificate Expiry Period is required')
            .min(1, 'Certificate Expiry Period must be at least 1 year')
            .max(5, 'Certificate Expiry Period cannot exceed 5 years')
            .typeError('Certificate Expiry Period must be a number')
    });

    const formik = useFormik({
        initialValues: {
            categoryName: editData?.categoryName || '',
            gracePeriod: editData?.gracePeriod || null,
            normalFee: editData?.normalFee || null,
            fine: editData?.fine || null,
            renewalFee: editData?.renewalFee || null,
            expiryDuration: editData?.expiryDuration || null
        },
        validationSchema: feeSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);
                const feeData = {
                    categoryName: values.categoryName,
                    gracePeriod: Number(values.gracePeriod),
                    normalFee: Number(values.normalFee),
                    fine: Number(values.fine),
                    renewalFee: Number(values.renewalFee),
                    expiryDuration: Number(values.expiryDuration)
                };

                if (isEditing) {
                    feeData.id = editData.id;
                    const response = await dispatch(handlePutRequest(feeData, '/api/fitness/fee',false, false));
                    if (response?.success) {
                        fetchFeesData();
                        onHideSidebar();
                        toast.success('Fitness fee updated successfully');
                    }
                    else {
                        toast.error(response?.message || 'Failed to update fitness fee');
                    }
                } else {
                    const response = await dispatch(handlePostRequest(feeData, '/api/fitness/fee',false, false));
                    if (response?.success) {
                        fetchFeesData();
                        onHideSidebar();
                        toast.success('Fitness fee added successfully');
                    }
                    else {
                        toast.error(response?.message || 'Failed to add fitness fee');
                    }
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error('Failed to process fitness fee');
            } finally {
                setLoading(false);
            }
        }
    });

    return (
        <>
            {loading && (
                <div
                    className="fixed top-0 left-0 w-full h-full flex items-center justify-center"
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(2px)',
                        zIndex: 1000
                    }}
                >
                    <Loader />
                </div>
            )}
            <div className="header-content">
                <h2>{isEditing ? 'Edit Fitness Fee' : 'Add Fitness Fee'}</h2>
                <Button icon="pi pi-times" onClick={onHideSidebar} className="close-button" />
            </div>

            {/* Form Content */}
            <div className="p-4">
                <form onSubmit={formik.handleSubmit} className="mt-2">
                    <div className="">
                        {/* Category Name Field */}
                        <div className="form-group">
                            <label className="form-label">Vehicle Category</label>
                            <InputText
                                id="categoryName"
                                name="categoryName"
                                value={formik.values.categoryName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className={`Input__Round ${formik.touched.categoryName && formik.errors.categoryName ? 'is-invalid' : ''}`}
                                // className={`form-control ${formik.touched.categoryName && formik.errors.categoryName ? 'is-invalid' : ''}`}
                                placeholder="Enter Vehicle Category"
                            />
                            {formik.touched.categoryName && formik.errors.categoryName && <div className="invalid-feedback">{formik.errors.categoryName}</div>}
                        </div>

                        {/* Grace Period Field */}
                        <div className="form-group">
                            <label className="form-label">Grace Period (days)</label>
                            <InputNumber
                                id="gracePeriod"
                                name="gracePeriod"
                                value={formik.values.gracePeriod}
                                onValueChange={(e) => formik.setFieldValue('gracePeriod', e.value)}
                               
                                mode="decimal"
                                min={0}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                useGrouping={false}
                                className={`Input__Round ${formik.touched.gracePeriod && formik.errors.gracePeriod ? 'is-invalid' : ''}`}
                                placeholder="Enter grace period in days"
                            />
                            {formik.touched.gracePeriod && formik.errors.gracePeriod && <div className="invalid-feedback">{formik.errors.gracePeriod}</div>}
                        </div>

                        {/* Normal Fee Field */}
                        <div className="form-group">
                            <label className="form-label">Normal Fee</label>
                            <InputNumber
                                id="normalFee"
                                name="normalFee"
                                value={formik.values.normalFee}
                                onValueChange={(e) => formik.setFieldValue('normalFee', e.value)}
                              
                                mode="currency"
                                currency="PKR"
                                min={0}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                useGrouping={false}
                                className={`Input__Round ${formik.touched.normalFee && formik.errors.normalFee ? 'is-invalid' : ''}`}
                                placeholder="Enter normal fee"
                            />
                            {formik.touched.normalFee && formik.errors.normalFee && <div className="invalid-feedback">{formik.errors.normalFee}</div>}
                        </div>

                        {/* Fine Field */}
                        <div className="form-group">
                            <label className="form-label">Fine</label>
                            <InputNumber
                                id="fine"
                                name="fine"
                                value={formik.values.fine}
                                onValueChange={(e) => formik.setFieldValue('fine', e.value)}
                               
                                mode="currency"
                                currency="PKR"
                                min={0}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                useGrouping={false}
                                className={`Input__Round ${formik.touched.fine && formik.errors.fine ? 'is-invalid' : ''}`}
                                placeholder="Enter fine amount"
                            />
                            {formik.touched.fine && formik.errors.fine && <div className="invalid-feedback">{formik.errors.fine}</div>}
                        </div>

                        {/* Renewal Fee Field */}
                        <div className="form-group">
                            <label className="form-label">Renewal Fee</label>
                            <InputNumber
                                id="renewalFee"
                                name="renewalFee"
                                value={formik.values.renewalFee}
                                onValueChange={(e) => formik.setFieldValue('renewalFee', e.value)}
                               
                                mode="currency"
                                currency="PKR"
                                min={0}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                useGrouping={false}
                                className={`Input__Round ${formik.touched.renewalFee && formik.errors.renewalFee ? 'is-invalid' : ''}`}
                                placeholder="Enter renewal fee"
                            />
                            {formik.touched.renewalFee && formik.errors.renewalFee && <div className="invalid-feedback">{formik.errors.renewalFee}</div>}
                        </div>

                        {/* Certificate Expiry Period Field */}
                        <div className="form-group">
                            <label className="form-label">Certificate Expiry Period</label>
                            <Dropdown
                                id="expiryDuration"
                                name="expiryDuration"
                                value={formik.values.expiryDuration}
                                options={[
                                    { label: '1 Year', value: 1 },
                                    { label: '2 Years', value: 2 },
                                    { label: '3 Years', value: 3 },
                                    { label: '4 Years', value: 4 },
                                    { label: '5 Years', value: 5 }
                                ]}
                                onChange={(e) => formik.setFieldValue('expiryDuration', e.value)}
                                onBlur={formik.handleBlur}
                                className={` ${formik.touched.expiryDuration && formik.errors.expiryDuration ? 'is-invalid' : 'Dropdown__Round w-full'}`}

                                // className={`form-control ${formik.touched.expiryDuration && formik.errors.expiryDuration ? 'is-invalid' : ''}`}
                                placeholder="Select certificate expiry period"
                            />
                            {formik.touched.expiryDuration && formik.errors.expiryDuration && <div className="invalid-feedback">{formik.errors.expiryDuration}</div>}
                        </div>

                        {/* Submit Button */}
                        <div className="mt-4">
                            <Button type="submit" label={isEditing ? 'Update Fee' : 'Add Fee'} className="submit-button" loading={loading} />
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default AddEditFee;
